<mat-toolbar>
  <mat-toolbar-row class="toolbar-content">
    <a routerLink="/" class="brand" [attr.aria-label]="environment.name">
      @if (environment.logo) {
        <img
          [src]="environment.logo"
          class="brand-logo"
          [alt]="environment.name"
        />
      } @else {
        <span class="brand-mark">💕</span>
      }

      @if (environment.showBrandName) {
        <span class="brand-name">{{ environment.name }}</span>
      }
    </a>

    <span class="spacer"></span>

    <div class="buttons">
      <a mat-stroked-button routerLink="/login" routerLinkActive="active-link">
        Login
      </a>
      <a
        mat-stroked-button
        routerLink="/register"
        routerLinkActive="active-link"
      >
        Register
      </a>
    </div>

    @if (showMenuButton()) {
      <button aria-label="Menu" mat-icon-button (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    }
  </mat-toolbar-row>
</mat-toolbar>
